<div class="product">
  <div class="image">
    <img [src]="imgUrl" [attr.alt]="name | translate" (click)="onProductSelect()">
  </div>
  <div *ngIf="!hideProductName" class="name">
    {{ name | translate}}
  </div>
  <div class="description">
    {{ description | translate}}
  </div>
  <div class="controls">
    <div class="row">
      <div class="add-product col-12 col-md-5">
        <app-button [title]="'Select' | translate" [buttonCssClass]="'button button-left button-black'"
          (clickEvent)="onProductSelect()"></app-button>
      </div>
      <div class="price col-12 col-md-7">{{ toMoneyStr(price) }}</div>
    </div>
  </div>
</div>
